/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// =============================================================================
// Badge de status da roteirização (handoff 0036 §1.2 / §5; semântica 0055 §4).
//
// ⚠️ NÃO derivamos o status no front. O backend expõe `derived_status`
// (pending|special|progress|done) PRONTO — `schedule_status` existe mas nunca
// transiciona. Este componente só mapeia o code → rótulo + cores do pill.
// Mesmo formato de pill consolidado no módulo (ItemStatusBadge/BillingCharges).
//
// Semântica dos buckets (0055 §4): pending = sem terminal e SEM rota
// (routes_count=0); special = sem terminal e ≥1 rota em preparação (manual OU
// otimizada) — por isso o rótulo é "Em preparação", não "Otimizada".
// =============================================================================

const StatusPill = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 3px 9px;
   border-radius: 999px;
   font-size: 11px;
   font-weight: 800;
   letter-spacing: 0.02em;
   text-transform: uppercase;
   border: 1px solid ${({ $border }) => $border ?? 'rgba(0,0,0,0.15)'};
   background: ${({ $bg }) => $bg ?? 'rgba(0,0,0,0.06)'};
   color: ${({ $text }) => $text ?? '#444'};
   white-space: nowrap;
`;

const STATUS_CONFIG = {
   pending: {
      label: 'Rascunho',
      bg: 'rgba(242,175,41,0.15)',
      border: 'rgba(242,175,41,0.5)',
      text: '#7d5a00',
   },
   special: {
      label: 'Em preparação',
      bg: 'rgba(99,102,241,0.12)',
      border: 'rgba(99,102,241,0.4)',
      text: '#3730a3',
   },
   progress: {
      label: 'Em execução',
      bg: 'rgba(55,138,221,0.12)',
      border: 'rgba(55,138,221,0.4)',
      text: '#0C447C',
   },
   done: {
      label: 'Concluída',
      bg: 'rgba(46,125,50,0.12)',
      border: 'rgba(46,125,50,0.35)',
      text: '#1b5e20',
   },
};

export default function ScheduleStatusBadge({ value }) {
   const cfg = STATUS_CONFIG[value] ?? {
      label: value ?? '—',
      bg: null,
      border: null,
      text: null,
   };
   return (
      <StatusPill $bg={cfg.bg} $border={cfg.border} $text={cfg.text}>
         {cfg.label}
      </StatusPill>
   );
}

ScheduleStatusBadge.propTypes = {
   value: PropTypes.oneOf(['pending', 'special', 'progress', 'done']),
};
